module.exports = __webpack_public_path__ + "img/7.9e3f5ba7.webp";